import {Box, Button, Slider, TextField, Typography, useTheme} from "@mui/material";
import {useSearchContext} from "../../../../Contexts/SearchContext";
import {useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {formatNumber} from "../../../../Utilities/postUtils";
import {CustomPopper} from "../../../Shared/Shared";
import Column from "../../../Common/Column";
import Space from "../../../Common/Space";
import Row from "../../../Common/Row";
import {FilterBoxMobile} from "./FilterBoxMobile";

export const PriceFilterMobile = (props) => {
    const theme = useTheme();
    const searchContext = useSearchContext();

    const start = searchContext.data.start;
    const range = searchContext.data.range;

    const [searchParams, setSearchParams] = useSearchParams();
    const priceParam = searchParams.get("price");
    const price = priceParam?.split(":") ?? ["", ""];

    const isActive = priceParam != null;
    const disabled = range[0] == range[1];

    const [sliderValue, setSliderValue] = useState([start[0], start[1]]);
    const [fieldValue, setFieldValue] = useState([price[0], price[1]]);
    const hasValue = fieldValue[0] !== "" || fieldValue[1] !== "";

    const [anchorEl, setAnchorEl] = useState(null);

    const anchorRef = React.useRef();
    const open = Boolean(anchorEl);

    const sliderMarks = [
        {
            value: disabled ? 1 : range[0],
            label: `${range[0]} kr`,
        },
        {
            value: disabled ? 3 : range[1],
            label: `${range[1]} kr`,
        }
    ];

    useEffect(() => {
        setSliderValue([start[0], start[1]]);
        setFieldValue([price[0], price[1]]);
    }, [start, priceParam, open]);

    const handleOpen = () => {
        setAnchorEl(anchorRef.current);
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleSliderChange = (event, newValue) => {
        setSliderValue(newValue);
        setFieldValue(newValue);
    }

    const handleMinFieldChange = (event) => {
        let newValue = formatNumber({
            value: event.target.value,
            useComma: false
        });

        setFieldValue(fieldValue => [newValue, fieldValue[1]])

        setSliderValue(value => {
            if (newValue == "")
                return [range[0], value[1]];

            if (newValue > value[1])
                return [value[1], value[1]];

            return [parseInt(newValue), value[1]];
        });
    }

    const handleMaxFieldChange = (event) => {
        let newValue = formatNumber({
            value: event.target.value,
            useComma: false
        });

        setFieldValue(fieldValue => [fieldValue[0], newValue])

        setSliderValue(value => {
            if (newValue == "")
                return [value[0], range[1]];

            if (newValue < value[0])
                return [value[0], value[0]];

            return [value[0], parseInt(newValue)];
        });
    }

    const handleMaxFieldBlur = () => {
        setFieldValue(value => {
            return [
                value[0],
                value[1] == "" ? "" : sliderValue[1]
            ]
        })
    }

    const handleMinFieldBlur = () => {
        setFieldValue(value => {
            return [
                value[0] == "" ? "" : sliderValue[0],
                value[1]
            ]
        })
    }

    const handleSave = () => {
        searchParams.delete("page");

        if (fieldValue[0] == "" && fieldValue[1] == "") {
            searchParams.delete("price");
        } else {
            searchParams.set("price", `${fieldValue[0]}:${fieldValue[1]}`);
        }

        setSearchParams(searchParams);
        handleClose();
    }

    const handleReset = () => {
        setSliderValue(range);
        setFieldValue(["", ""]);
    }

    return <Box>
        <FilterBoxMobile
            title={"Pris"}
            anchorRef={anchorRef}
            onOpen={handleOpen}
            numberOfActiveFilters={isActive ? 1 : 0}
            sx={{position: "relative"}}
        />
        <CustomPopper
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
        >
            <Box
                sx={{minWidth: "250px"}}
            >
                <Column sx={{display: "flex", justifyContent: "end"}}>
                    <Typography
                        sx={{
                            width: "fit-content",
                            fontWeight: hasValue ? "bold" : "normal",
                            color: hasValue ? theme.palette.jagtred.main : "grey",
                            cursor: hasValue ? "pointer" : "default",
                            pointerEvents: hasValue ? "auto" : "none",
                        }}
                        onClick={handleReset}
                    >
                        Nulstil
                    </Typography>
                </Column>
                <Space height="10px"/>
                <Row sx={{justifyContent: "space-between"}}>
                    <TextField
                        sx={{maxWidth: "100px"}}
                        label={"Fra"}
                        value={fieldValue[0]}
                        onChange={handleMinFieldChange}
                        onBlur={handleMinFieldBlur}
                    />
                    <TextField
                        sx={{maxWidth: "100px"}}
                        label={"Til"}
                        value={fieldValue[1]}
                        onChange={handleMaxFieldChange}
                        onBlur={handleMaxFieldBlur}
                    />
                </Row>
                <Space height="5px"/>
                <Row>
                    <Slider
                        disabled={disabled}
                        value={disabled ? 2 : sliderValue}
                        onChange={handleSliderChange}
                        marks={sliderMarks}
                        min={disabled ? 1 : range[0]}
                        max={disabled ? 3 : range[1]}
                        valueLabelDisplay="auto"
                        sx={{
                            color: theme.palette.jagtred.main,
                            "& .MuiSlider-mark": {
                                color: "transparent",
                            },
                            margin: "10px"
                        }}
                    />
                </Row>
                <Space height="15px"/>
                <Box sx={{textAlign: "end"}}>
                    <Button
                        variant="contained"
                        color="jagtred"
                        sx={{margin: "5px 0 10px 0"}}
                        onClick={handleSave}
                    >
                        Gem
                    </Button>
                </Box>
            </Box>
        </CustomPopper>
    </Box>
}